import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useCustomerValue } from "providers/CustomerContext";
import { useState } from "react";
import { removeCustomerLogo } from "services/data.internal.service";
import { getCustomerLogo } from "services/data.internal.service";
import { uploadCustomerLogo } from "services/data.internal.service";
import { Success, Error_ } from "ui-components/Alert";
import { TitleField } from "ui-components/Form";

function CustomerLogo({type}) {
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const [newImages, setNewImages] = useState([]);
  const [savedImages, setSavedImages] = useState([]);
  const queryClient = useQueryClient();
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  useQuery({
    queryKey: ["logo", {type}],
    queryFn: () => getCustomerLogo({ customerCode, type }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => {
      const image = data.data.data;
      if (Boolean(image)) {
        const saved = [image];
        setSavedImages(saved);
      } else {
        setSavedImages([]);
      }
    },
    onError,
  });
  const onFileChange = (file) => {
    let isImageSizeValid = true;
    let isImageFormatValid = true;

    let fileArray = [];
    for (let i = 0; i < file.length; i++) {
      fileArray.push(file[i]);
    }

    fileArray.forEach((x) => {
      if (x.size > 1 * 1024 * 1024) {
        isImageSizeValid = false;
      }
      const fileName = x.name;
      const fileExtension = fileName.split(".")[1];
      if (!["jpeg", "png"].includes(fileExtension)) {
        isImageFormatValid = false;
      }
    });

    if (!isImageSizeValid) {
      document.getElementById("files").value = null;
      setAlert(<Error_ content="Image size must less than 1 mb" onChange={setAlert} />);
      return;
    }

    if (!isImageFormatValid) {
      document.getElementById("files").value = null;
      setAlert(<Error_ content="Invalid image format must be png/jpeg" onChange={setAlert} />);
      return;
    }

    let imageUrl = [];

    fileArray.forEach((x) => {
      let temp = URL.createObjectURL(x);
      let imageObj = {
        file: x,
        tempUrl: temp,
      };

      imageUrl.push(imageObj);
    });
    setNewImages(imageUrl);

    document.getElementById("files").value = null;
  };

  const removeMutation = useMutation(removeCustomerLogo, {});

  const onDelete = () => {
    setNewImages([]);
  };
  const onDeleteSaved = () => {
    removeMutation.mutate(
      { customerCode, type },
      {
        onSuccess: (data) => {
          queryClient.invalidateQueries(["logo"]);
          setAlert(<Success data={data} onChange={setAlert} />);
        },
        onError,
      }
    );
  };

  const uploadMutation = useMutation(uploadCustomerLogo, {});

  const onUpload = () => {
    if (newImages.length === 0) return;
    let formData = new FormData();
    formData.append("customerCode", customerCode);
    formData.append("type", type);
    formData.append("logo", newImages[0].file, newImages[0].file.name);
    uploadMutation.mutate(formData, {
      onSuccess: (data) => {
        setNewImages([]);
        queryClient.invalidateQueries(["logo"]);
        setAlert(<Success data={data} onChange={setAlert} />);
      },
      onError,
    });
  };
  return (
    <MDBox>
      <TitleField label={`${type} (Image size must less than 1 mb, png/jpeg only)`} />
      {alert}
      <MDBox>
        <input
          id="files"
          name="logo"
          type="file"
          onChange={(e) => {
            onFileChange(e.target.files);
          }}
        />
      </MDBox>
      {/* {JSON.stringify(newImages)} */}
      {newImages.map((image, i) => (
        <MDBox sx={{ marginTop: "5px" }} key={i}>
          <MDTypography color="info">Preview</MDTypography>
          <MDBox
            sx={{
              width: "250px",
              height: "150px",
              border: "2px dotted black",
              borderRadius: ".2rem",
              marginBottom: "1rem",
            }}
          >
            <img style={{ width: "100%", height: "100%" }} src={image.tempUrl} />
          </MDBox>

          <MDButton color="success" variant="gradient" size="small" onClick={onUpload}>
            upload
          </MDButton>
          <MDButton
            sx={{ marginLeft: "1rem" }}
            color="error"
            variant="gradient"
            size="small"
            onClick={onDelete}
          >
            delete preview
          </MDButton>
        </MDBox>
      ))}
      {savedImages.map((image, i) => (
        <MDBox sx={{ marginTop: "5px" }} key={i}>
          <MDTypography color="info">Saved</MDTypography>
          <MDBox
            sx={{
              width: "250px",
              height: "150px",
              border: "2px dotted black",
              borderRadius: ".2rem",
              marginBottom: "1rem",
            }}
          >
            <img style={{ width: "100%", height: "100%" }} src={image} />
          </MDBox>
          <MDButton color="error" variant="gradient" size="small" onClick={onDeleteSaved}>
            delete saved
          </MDButton>
        </MDBox>
      ))}
    </MDBox>
  );
}

export default CustomerLogo;
